<template>
  <a
    v-if="address"
    :href="link"
    target="_blank"
    rel="noopener"
    class="link with-arrow"
    itemprop="hasMap"
  >
    <SpriteSymbol name="map" />
    <span>Google Maps</span>
  </a>
</template>

<script lang="ts" setup>
import type { AddressCardFragment } from '#graphql-operations'

// Old props:
/*
props: {
 address: {
   type: Object,
   default: undefined,
 } as PropOptions<AddressCardFragment['address']>,
 location: {
   type: Object,
   default: undefined,
 } as PropOptions<AddressCardFragment['location']>,
}
*/

const props = defineProps<{
  address?: AddressCardFragment['address']
  location?: AddressCardFragment['location']
}>()

// Old computed:
/*
computed: {
 link() {
   const destination = [
     this.address?.organization,
     this.address?.addressLine1,
     this.address?.postalCode + ' ' + this.address?.locality,
   ]
     .filter(falsy)
     .map((v) => v.trim())
     .join(', ')
   return `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=transit`
 }
}
*/

const link = computed(() => {
  const destination = [
    props.address?.organization,
    props.address?.addressLine1,
    props.address?.postalCode + ' ' + props.address?.locality,
  ]
    .filter(Boolean)
    .map((v) => v?.trim())
    .join(', ')
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}&travelmode=transit`
})
</script>
